import React from 'react'
import { connect } from 'react-redux'
import imgFeatureList1 from '../../images/public/calendar-check.png'
import imgFeatureList2 from '../../images/public/clock.png'
import imgFeatureList3 from '../../images/public/list-alt.png'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'
import SupportList from '../partials/SupportList.jsx'
import CallToActRegister from '../partials/CallToActRegister.jsx'
import BlogList from '../partials/BlogList.jsx'

class ArticlesGlobalHiring extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {

    return (
			<main>
      <section className="homepage-feature">
				<Header isNavbarFixed={true} />
				<div className="homepage-feature-list bg-global">
          <div className="container">
            <h2 className="heading1 m-b-76">Astronaut for Global Hiring</h2>
            <div className="flex flex-around">
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList1} alt="Fit into their schedule" />
                </div>
                <div className="heading4 bold">
									FIT INTO THEIR SCHEDULE
                </div>
              </div>
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList2} alt="Save time and cost with convenience"/>
								</div>
                <div className="heading4 bold">
                  SAVE TIME & COST WITH <br />CONVENIENCE
                </div>
              </div>
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList3} alt="Keep control and consistency" />
								</div>
                <div className="heading4 bold">
                  KEEP CONTROL & <br />CONSISTENCY
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
			<section className="article-page-title">
				<div className="heading2">Case Study</div>
				<div className="heading1 larger">Contact us for more details.</div>
			</section>
      <SupportList />
      <CallToActRegister />
			<BlogList />
      <Footer />
    </main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticlesGlobalHiring)
